import axios from 'axios';

// Public, key-less API — no auth header required.
const client = axios.create({
  baseURL: process.env.REACT_APP_SQUAREYARDS_API_URL,
});

export const getAmcList = () =>
  client.get('/amcs').then((res) => res.data?.AMCListResponse || []);

export const getAmcRateCard = (amcId) =>
  client.get(`/amcs/${amcId}/rate-card`).then((res) => {
    const data = Array.isArray(res.data) ? res.data[0] : res.data;
    return data || null;
  });
